import React from 'react'
import { BasePopover } from 'components/common/popover/BasePopover'

interface PopoverAutoCloseProps {
  anchor: React.ReactElement
  children: React.ReactNode
  placement?: string
}

export const PopoverAutoClose: React.FC<PopoverAutoCloseProps> = (props) => {
  return <BasePopover {...props} closeOnClick />
}
